import { render, staticRenderFns } from "./ViolationList.vue?vue&type=template&id=618e8638&scoped=true"
import script from "./ViolationList.vue?vue&type=script&lang=js"
export * from "./ViolationList.vue?vue&type=script&lang=js"
import style0 from "./ViolationList.vue?vue&type=style&index=0&id=618e8638&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618e8638",
  null
  
)

export default component.exports